import { render, staticRenderFns } from "./LayoutSecretKeyOutdated.vue?vue&type=template&id=28b7cf13&scoped=true"
import script from "./LayoutSecretKeyOutdated.vue?vue&type=script&lang=js"
export * from "./LayoutSecretKeyOutdated.vue?vue&type=script&lang=js"
import style0 from "./LayoutSecretKeyOutdated.vue?vue&type=style&index=0&id=28b7cf13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7cf13",
  null
  
)

/* custom blocks */
import block0 from "./LayoutSecretKeyOutdated.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports